import { AdBlockerUpsell } from 'components/upsell-prompts/ad-blocker-upsell'
import { useAdBlockerDetection } from 'hooks/use-ad-blocker-detection'
import React from 'react'

export const AdBlockerDetection: React.FC = () => {
  const { isAdBlockerActive } = useAdBlockerDetection()

  // Don't show anything if detection is still initializing or if no ad-blocker is detected
  if (!isAdBlockerActive) {
    return null
  }

  return <AdBlockerUpsell />
}
